import React, { useState } from "react";
import { BsCheck } from "react-icons/bs";
import { Switch, Modal, Input, Alert } from "antd";
import { HiTrash } from "react-icons/hi";
import {
  deleteFillout,
  deleteFlowdesk,
  deleteFlowdeskPopup,
  deleteInstagram,
  deleteNewsletter,
  deletePinterest,
  deletePodcast,
  deleteTiktok,
  deleteYoutube,
} from "../../Utils/SupabaseServices/UserDatabase";
import { useParams } from "react-router-dom";
import { FaLock } from "react-icons/fa";
import "../Header/Header.css";
import { PiSealWarning } from "react-icons/pi";

const IntegrationPlatforms = (props: any) => {
  const { username } = useParams();
  const {
    platformName,
    isConnected,
    isProcessing,
    isPlatformEnabled,
    onTogglePlatform,
    onConnectPlatform,
    onDeletePlatform,
    showConfirmation,
    platformTodelete,
    userId,
    refetchData,
    subscription_type,
    first_connected_platform,
    label,
  } = props;
  const [warningModalOpen, setWarningModalOpen] = useState(false);
  // Add flags to identify platform types
  const isAffiliatePlatform = ["Amazon", "ShopMy", "LTK"].includes(
    platformName
  );
  const isCustomDomainPlatform = ["Custom Domain"].includes(platformName);
  const isContentPlatform = [
    "Instagram",
    "YouTube",
    "TikTok",
    "X",
    "LinkedIn",
    "Newsletter",
    "Podcast",
  ].includes(platformName);

  const handleCancelDelete = () => {
    props.setShowConfirmation(false);
  };
  const handleConfirmDelete = async (platform: any) => {
    switch (platform) {
      case "Instagram":
        await deleteInstagram(username, userId).then(() => {
          refetchData();
        });
        break;

      case "YouTube":
        await deleteYoutube(username, userId).then(() => {
          refetchData();
        });

        break;

      case "Podcast":
        await deletePodcast(username, userId).then(() => {
          refetchData();
        });

        break;

      case "Newsletter":
        await deleteNewsletter(username, userId).then(() => {
          refetchData();
        });

        break;

      case "TikTok":
        await deleteTiktok(username, userId).then(() => {
          refetchData();
        });

        break;

      case "Pinterest":
        await deletePinterest(username, userId).then(() => {
          refetchData();
        });
        break;

      case "Flodesk Inline":
        await deleteFlowdesk(username, userId).then(() => {
          refetchData();
        });
        break;
      case "Flodesk Popup":
        await deleteFlowdeskPopup(username, userId).then(() => {
          refetchData();
        });
        break;
      case "Fillout":
        await deleteFillout(username, userId).then(() => {
          refetchData();
        });

        break;

      default:
        break;
    }

    props.setShowConfirmation(false);
  };
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOk = () => {
    return (
      <a
        href="https://payments.thesearchbubble.com/p/login/14kg1ecrU8Lt8vK4gg"
        target="_blank"
      >
        <button className="upgrade-subscription">Upgrade</button>
      </a>
    );
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  // Helper function to determine if platform is available
  const isPlatformAvailable = () => {
    if (first_connected_platform === platformName) {
      return true;
    }

    if (
      subscription_type === "basic" &&
      first_connected_platform !== platformName
    ) {
      return false;
    }

    return true;
  };

  // Render appropriate status element based on platform state
  const renderStatusElement = () => {
    if (!isPlatformAvailable()) {
      return (
        <div className="platform-lock" onClick={() => setIsModalOpen(true)}>
          <FaLock className="lock-icon" />
        </div>
      );
    }

    if (isProcessing) {
      if (!isConnected) {
        return (
          <button
            className="status-badge processing"
            // onClick={isCustomDomainPlatform ? onConnectPlatform : null}
          >
            <span>Processing</span>
          </button>
        );
      } else {
        return (
          <button className="connected-button">
            <span className="connected-text">Connected</span>
          </button>
        );
      }
    } else {
      return (
        <button className="connect-button" onClick={onConnectPlatform}>
          Connect
        </button>
      );
    }
  };

  return (
    <div className="platform-card">
      <div className="platform-info">
        <p
          className={isConnected ? "platform-name connected" : "platform-name"}
        >
          {platformName === "Twitter" ? "X" : platformName} {" "}
          {isProcessing && !isConnected && isCustomDomainPlatform && (
            <PiSealWarning onClick={()=>setWarningModalOpen(true)} style={{color:"#c4930a",fontSize:"1.2rem"}}/>

          )}
        </p>

        {isProcessing && !isConnected && !isCustomDomainPlatform && (
          <div
            style={{
              backgroundColor: "rgba(36, 70, 240, 0.08)",
              borderRadius: "6px",
              padding: "0.5rem 0.75rem",
              fontSize: "0.875rem",
              flex: 1,
              marginRight: "10px",
            }}
          >
            

              <p style={{ margin: 0, color: "#2446f0" }}>
                We are processing your {platformName}{" "}
                {isAffiliatePlatform ? "products" : "content"}.
              </p>
            
          </div>
        )}

        {label && <p className="platform-username">{label}</p>}
      </div>

      <div className="platform-status-container">{renderStatusElement()}</div>

      {/* <div className="platform-actions">
        <Switch
          className="platform-toggle"
          checked={isPlatformEnabled}
          onChange={onTogglePlatform}
          disabled={!isConnected && !isProcessing}
        />
      </div> */}

      <Modal
        title="Upgrade Your Plan"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={[
          <button
            key="cancel"
            onClick={handleCancel}
            className="modal-cancel-btn"
          >
            Cancel
          </button>,
          <a
            key="upgrade"
            href="https://payments.thesearchbubble.com/p/login/14kg1ecrU8Lt8vK4gg"
            target="_blank"
          >
            <button className="modal-upgrade-btn">Upgrade</button>
          </a>,
        ]}
      >
        <p className="upgrade-text">
          Upgrade to a pro plan to connect more platforms and unlock additional
          features.
        </p>
      </Modal>

      {showConfirmation && platformTodelete === platformName && (
        <div className="confirmation-dialog">
          <p className="platform-name">
            Are you sure you want to delete {platformName}'s integration and its
            data?
          </p>
          <button className="confirm-btn cancel" onClick={handleCancelDelete}>
            Cancel
          </button>
          <button
            className="confirm-btn confirm confirm-btn-color"
            onClick={() => handleConfirmDelete(platformName)}
          >
            Delete
          </button>
        </div>
      )}
      {warningModalOpen && (
       <Modal
      //  title="Action Required!"
       open={warningModalOpen}
       onCancel={()=>setWarningModalOpen(false)}
       footer={null}
       getContainer={false}
             focusTriggerAfterClose={false}

       >
         
         <div style={{ marginTop: 24 }}>
          <Input
            placeholder="yourdomain.com"
            value={label}
            disabled={true}
            style={{ marginBottom: 12 }}
          />
          <Alert
            message={
              <div>
                <div>
                  <b>Almost there! We'll verify your domain setup:</b>
                </div>
                <div style={{ marginTop: 12 }}>
                  We'll check if your domain is properly connected. This might
                  take upto 24 hours after you've updated your nameservers.
                </div>
                {/* <div style={{ marginTop: 12 }}>
                  <b>If you haven't updated your nameservers yet:</b>
                  <ul style={{ margin: "12px 0" }}>
                    {(data?.name_servers || []).map(
                      (ns: string, idx: number) => (
                        <li key={idx} style={{ fontFamily: "monospace" }}>
                          {ns}
                        </li>
                      )
                    )}
                  </ul>
                  <div style={{ marginTop: 8 }}>
                    Please update these at your domain provider (like GoDaddy,
                    Namecheap, etc.) before clicking Done.
                  </div>
                </div> */}
              </div>
            }
            type="warning"
            showIcon
          />
        </div>
    
       </Modal>
      )}
    </div>
  );
};

export default IntegrationPlatforms;
